import { render, staticRenderFns } from "./InventarioFlorestal.vue?vue&type=template&id=416ab4b8&scoped=true"
import script from "./InventarioFlorestal.vue?vue&type=script&setup=true&lang=ts"
export * from "./InventarioFlorestal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InventarioFlorestal.vue?vue&type=style&index=0&id=416ab4b8&prod&lang=css"
import style1 from "../../../css/crud.css?vue&type=style&index=1&id=416ab4b8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416ab4b8",
  null
  
)

export default component.exports